import { createContext, useState, useContext, useEffect } from "react";

const AudioContext = createContext();

// Change this link to your bill audio file URL in a week 
const audioFile = "https://res.cloudinary.com/dqqyqsyhb/video/upload/v1743533297/audio_if8ay6.mp3";

export const AudioProvider = ({ children }) => {
  const [isPlaying, setIsPlaying] = useState(false);
  const audio = new Audio(audioFile);

  console.log("audio file: " + audioFile)
  useEffect(() => {
    if (isPlaying) {
      audio.load(); // Ensure the file is loaded
      audio.play().catch((err) => console.error("Audio play error:", err));
      audio.onended = () => setIsPlaying(false);
    }
  }, [isPlaying]);

  return (
    <AudioContext.Provider value={{ isPlaying, setIsPlaying }}>
      {children}
    </AudioContext.Provider>
  );
};

export const useAudio = () => useContext(AudioContext);
